import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { queryClient } from "App";
import axiosConfig from "axiosConfig";
import { TOAST_TYPES_ENUM } from "enums";
import { Toast } from "shared";

export const useDeleteUser = (
  options?: UseMutationOptions<any, Error>,
  withoutToast?: boolean
) => {
  return useMutation({
    mutationKey: ["userDelete"],
    mutationFn: async () => {
      return axiosConfig.delete(`/users`).then((res) => res.data);
    },
    onMutate: () => {
      if (!withoutToast) {
        Toast({
          message: "Ładowanie...",
          type: TOAST_TYPES_ENUM.LOADING,
          id: "userDelete",
        });
      }
      if (options && options.onMutate) {
        return options.onMutate();
      }
    },
    onSuccess: (data, variables, context) => {
      if (!withoutToast) {
        Toast({
          message: "Pomyślnie Usunięto",
          type: TOAST_TYPES_ENUM.SUCCESS,
          id: "userDelete",
        });
      }
      setTimeout(() => {
        queryClient.invalidateQueries({ queryKey: ["me"] });
      }, 100);

      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },

    onError: (error, variables, context) => {
      if (!withoutToast) {
        Toast({
          message: "Błąd podczas usuwania",
          type: TOAST_TYPES_ENUM.ERROR,
          id: "userDelete",
        });
      }
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};
